import React, { useState } from "react";
import Button from "../UniversalComponents/DefaultButton";

const AddPermissionForm = ({ close, data }) => {
  const [formData, setFormData] = useState({
    Name: "",
    Description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("name,value", name, value);

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="mt-8 w-full h-full rounded-md border border-[#D2DAE1] bg-white flex flex-col">
      <div className="pl-4 pt-4 pr-9 flex gap-3">
        <div className="w-1/3">
          <label htmlFor="name" className="text-[#434852] font-poppins text-[12px] font-normal">
            Name <span className="mb-1 text-red-500"></span>
          </label>
          <input
            type="text"
            id="Name"
            name="Name"
            value={formData.Name}
            onChange={(e) => handleChange(e)}
            placeholder="Enter Name"
            className="w-full rounded-md text-sm font-400  px-4 py-1 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-500"
            required
          />
        </div>

        <div className="w-2/3">
          <label htmlFor="name" className="text-[#434852] font-poppins text-[12px] font-normal">
            Description <span className="mb-1 text-red-500"></span>
          </label>
          <input
            type="text"
            id="Description"
            name="Description"
            value={formData.Description}
            onChange={(e) => handleChange(e)}
            placeholder="Description"
            className="w-full rounded-md text-sm font-400  px-4 py-1 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-500"
            required
          />
        </div>
      </div>
      <div className="flex flex-col min-h-0 grow">
        <div className="min-h-0 grow flex flex-col">
          <div className="text-[#888] font-[Poppins] text-[14px] font-normal leading-[150%] capitalize pl-6 pt-4">
            Company
          </div>
          <div className=" mx-6 min-h-0 grow border-t border-[#BECBD3] "></div>
        </div>
        <div className="flex justify-end gap-1 p-4 border-t border-[#BECBD3] shadow-md ">
          <Button onClick={close}>Cancel</Button>
          <Button variant={"primary"}>Save</Button>
        </div>
      </div>
    </div>
  );
};

export default AddPermissionForm;
